import { createStore } from 'zustand/vanilla';

import type { CourseQuizGenerationLockStore } from './types';

// ------------- Initial State -------------

const INITIAL_STATE: Pick<CourseQuizGenerationLockStore, 'isLocked' | 'generatingCardIndex'> = {
  isLocked: false,
  generatingCardIndex: null,
};

// ------------- Store Factory -------------

/**
 * Zustand store for locking the course editor during quiz AI generation.
 * Disables reorder, unit cards, footer actions, and course save/publish in the header.
 */
export function createCourseQuizGenerationLockStore() {
  return createStore<CourseQuizGenerationLockStore>()((set, get) => ({
    // ------------- Initial State -------------
    ...INITIAL_STATE,

    // ------------- Actions -------------

    setLocked: (locked: boolean): void => {
      const { isLocked: current } = get();
      if (locked === current) {
        return;
      }
      set({ isLocked: locked });
    },

    startGenerating: (cardIndex: number): void => {
      set({ isLocked: true, generatingCardIndex: cardIndex });
    },

    stopGenerating: (): void => {
      set({ isLocked: false, generatingCardIndex: null });
    },

    reset: (): void => {
      set(INITIAL_STATE);
    },
  }));
}

// ------------- Store Type -------------

export type CourseQuizGenerationLockStoreApi = ReturnType<typeof createCourseQuizGenerationLockStore>;
